import { Button, Text, Box, Message } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'

const CapitalEfficiencyWarning = ({ setShowCapitalEfficiencyWarning, getSetFullRange }) => {
  const { t } = useTranslation()
  return (
    <Message variant="warning">
      <Box>
        <Text fontSize="16px">{t('Efficiency Comparison')}</Text>
        <Text color="textSubtle">{t('Full range positions may earn less fees than concentrated positions.')}</Text>
        <Button
          mt="16px"
          onClick={() => {
            setShowCapitalEfficiencyWarning(false)
            getSetFullRange()
          }}
          scale="md"
          variant="secondary"
        >
          {t('I understand')}
        </Button>
      </Box>
    </Message>
  )
}

export default CapitalEfficiencyWarning
